import { createElement } from 'react';

import { editBox, view } from './TextFieldBox.less';

const TextFieldBox = ({
  editing,
  input,
  meta,
  localeMessage,
  formValues,
  hintLocale,
  textPlaceholder = null,
  viewStyle = {},
  ...other
}) =>
  editing
    ? createElement('input', {
        className: editBox,
        name: input.name,
        value: input.value,
        placeholder: textPlaceholder || (hintLocale && localeMessage(hintLocale)),
        onChange: input.onChange,
        style: viewStyle,
        ...other,
      })
    : createElement('div', { className: view, style: viewStyle }, input.value);

// This if there is need to use the textBox without a form providing values and such
export const TextFieldBoxNoForm = ({ name, value, hintLocale, onChange, viewStyle = {}, ...other }) =>
  createElement('input', {
    className: editBox,
    name: name || 'textFieldBoxNoForm',
    placeholder: hintLocale,
    onChange: onChange,
    style: viewStyle,
    ...other,
  });

export default TextFieldBox;
